import type { ReactNode } from "react";
import { useAccount } from "wagmi";
import { isBefore } from "date-fns/isBefore";
import { GameProvider } from "@looksrare/uikit";
import { ChainId } from "@looksrare/config";
import { FlipperConfig } from "@looksrare/classic-games/flipper";
import { gameAddresses } from "@/config";
import { useUser } from "@/queries/user";
import { useGlobalSettings } from "@/hooks";

export const YoloGamesFlipperProvider = ({ children }: { children: ReactNode }) => {
  const { address } = useAccount();
  const { data: user } = useUser(address!, { enabled: !!address });
  const isSoundEnabled = useGlobalSettings((state) => state.isSoundEnabled);

  return (
    <GameProvider<FlipperConfig>
      widgetBotOptions={{
        server: "1204359490925764680",
        channel: "1247424243126505543",
        shard: "https://emerald.widgetbot.io",
        glyph: ["/images/win/chat.png", "32px"],
        color: "#CCFD07",
        notifications: false,
        indicator: true,
      }}
      supportedNetworks={["blast"]}
      addresses={gameAddresses}
      fallbackChainId={ChainId.BLAST_MAINNET}
      config={{
        isMuted: !isSoundEnabled,
        supportedCurrencies: ["ETH", "YOLO"],
        isWalletBlocked: !!user?.selfTimeoutUntil && isBefore(Date.now(), user?.selfTimeoutUntil),
        selfTimeoutUntil: user?.selfTimeoutUntil,
        points: {
          enabled: false,
        },
      }}
    >
      {children}
    </GameProvider>
  );
};
